import React from 'react'

import { ReactComponent as ChatIcon } from 'assets/svg/settings/chat.svg'
import { ReactComponent as ReportIcon } from 'assets/svg/settings/report.svg'

export const HelpConfig = [
    {
        id: 0,
        name: 'chat',
        icon: <ChatIcon />
    },
    {
        id: 1,
        name: 'report',
        icon: <ReportIcon />
    }
]
